



































































































































































































































































import { Component, Prop, PropSync, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import VReservation from "@/shared/models/vReservation";
import { reservationStatuses } from "@/shared/models/vReservation";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { SortableTableHeader } from "@/components/generic-pms-table/SortableTableDirective";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import DateField from "@/components/misc/DateField.vue";
import NoData from "@/components/misc/NoData.vue";
import { AppParam } from "@/shared/models/appParam";
import { FinancialSettingsType } from "@/store/modules/financial";
import { AddOnServiceTranslation } from "@/shared/models/addOnService";
import { ServiceType } from "@/shared/models/serviceType";
import { ReservationAccUnitModel } from "@/components/reservation-form/types";
import { parseStringToDateJS } from "@/shared/dateFormatUtils";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import { MultipleReservationsInvoicingViewModel } from "./types";
import * as _ from "lodash";

@Component({
  components: {
    SortableHeadersTable,
    DateField,
    LoadingOverlay,
    NoData,
  },
})
export default class MultipleReservationsInvoice extends Vue {
  @PropSync("open", { default: false }) internalOpen?: boolean;

  @Prop() reservationHolderName?: string;
  @Prop() selectedPropertyId?: number;
  @Prop({ default: () => [] }) servicePeriod?: string[];

  @Action("appParams/refreshAppParams") refreshAppParams?: () => Promise<void>;
  @Getter("appParams/appParams") appParams?: AppParam[];
  @Getter("appParams/tenantUsesOfficialRates")
  tenantUsesOfficialRates?: boolean;

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes")
  serviceTypes?: ServiceType[];

  @Getter("language/language") language?: string;

  async created() {
    const promises = [];

    if ((this.appParams?.length ?? 0) === 0 && this.refreshAppParams) {
      promises.push(this.refreshAppParams());
    }
    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      promises.push(this.refreshServiceTypes());
    }

    await Promise.all(promises);
  }

  settingsOpen = false;

  headers: SortableTableHeader[] = [
    {
      text: "Period",
      value: "period",
      active: false,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Reservation.ArrivalDate",
      value: "arrivalDate",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Reservation.DepartureDate",
      value: "departureDate",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Reservation holder",
      value: "reservationHolderName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Guest",
      value: "reservationGuestName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Accomodation unit",
      value: "accomodationUnitTypeName",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Reservation status",
      value: "statusId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Reservation Id",
      value: "reservationId",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Total price",
      value: "totalPrice",
      active: true,
      default: false,
      class: "resize-header",
      exportHeaders: [],
    },
    {
      text: "Actions",
      value: "actions",
      sortable: false,
      active: true,
      default: true,
      class: "resize-header",
      exportHeaders: [],
    },
  ];

  get serviceArrivalPeriod() {
    const res = [
      this.filters.arrivalDateFromPeriod
        ? this.filters.arrivalDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.arrivalDateToPeriod
        ? this.filters.arrivalDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set serviceArrivalPeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.arrivalDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.arrivalDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.arrivalDateFromPeriod = "";
      this.filters.arrivalDateToPeriod = "";
    }
  }

  get serviceDeparturePeriod() {
    const res = [
      this.filters.departureDateFromPeriod
        ? this.filters.departureDateFromPeriod.substring(0, 10) ?? ""
        : "",
      this.filters.departureDateToPeriod
        ? this.filters.departureDateToPeriod.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set serviceDeparturePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.departureDateFromPeriod = val.length > 0 ? val[0] : "";
      this.filters.departureDateToPeriod = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.departureDateFromPeriod = "";
      this.filters.departureDateToPeriod = "";
    }
  }

  filters = {
    reservationId: "",
    arrivalOrDepartureDate: "",
    bookingDate: "",
    arrivalDateFromPeriod: "",
    arrivalDateToPeriod: "",
    departureDateFromPeriod: "",
    departureDateToPeriod: "",
    optionExpirationDate: "",
    reservationHolderName: "",
    reservationGuestName: "",
    accomodationUnitName: "",
    otachannelName: "",
    statusId: null as number | null,
  };

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("internalOpen")
  watchOpen(fresh: boolean) {
    if (fresh) {
      this.filters.reservationHolderName = this.reservationHolderName ?? "";
      if (this.servicePeriod && this.servicePeriod.length == 2) {
        this.filters.departureDateFromPeriod = this.servicePeriod[0];
        this.filters.departureDateToPeriod = this.servicePeriod[1];
      }
    }

    if (fresh && this.initLoaded) {
      this.options.page = 1;
      this.debouncedLoad();
    }

    if (!fresh) {
      this.selected = [];
      (this.filters.reservationId = ""),
        (this.filters.arrivalOrDepartureDate = ""),
        (this.filters.bookingDate = ""),
        (this.filters.arrivalDateFromPeriod = ""),
        (this.filters.arrivalDateToPeriod = ""),
        (this.filters.departureDateFromPeriod = ""),
        (this.filters.departureDateToPeriod = ""),
        (this.filters.optionExpirationDate = ""),
        (this.filters.reservationHolderName = ""),
        (this.filters.reservationGuestName = ""),
        (this.filters.accomodationUnitName = ""),
        (this.filters.otachannelName = ""),
        (this.filters.statusId = null as number | null),
        (this.list = {
          result: [],
          count: 0,
        });
    }
  }

  // TODO: something is getting fucked here, 'sortBy' changes to NULL randomly
  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["arrivalDate"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  loading = true;
  list: ListModel<VReservation & { idUniq: string }> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);

  firstLoad = true;
  initialListSize = 0;

  async load(): Promise<typeof MultipleReservationsInvoice.prototype.list> {
    this.loading = true;
    return this.axios
      .get<ListModel<VReservation>>("/reservations", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = {
          result: res.data.result.map((x) => ({
            ...x,
            idUniq: `${x.reservationId}:${x.reservationAccUnitTypeId}`,
          })),
          count: res.data.count,
        };
        if (this.firstLoad) {
          this.initialListSize = this.list.count ?? 0;
        }
        return this.list;
      })
      .finally(() => {
        this.scrollToTop();
        this.firstLoad = false;
        this.loading = false;
      });
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy[0] == "period"
          ? ["arrivalDate"]
          : this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      ...this.filters,
      isFilteredByDate: false,
    };
  }

  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }

  get statuses() {
    return reservationStatuses;
  }

  statusStyle(statusId: number) {
    return this.statuses.find((x) => x.id == statusId) ?? {};
  }

  //selection
  selected = [] as VReservation[];

  async addToInvoice() {
    if (!this.storedSettings && this.refreshSettings) {
      await this.refreshSettings();
    }

    await this.refreshAddOnServicesTranslations();

    const request = {
      reservationAccUnitTypeIds: this.selected.map(
        (x) => x.reservationAccUnitTypeId
      ),
      selectedPropertyId: this.selectedPropertyId,
    };

    this.axios
      .post<MultipleReservationsInvoicingViewModel>(
        "/financialDocuments/GetMultipleReservationsInvoicingData",
        request
      )
      .then(async (res) => {
        this.$emit(
          "mergeReservations",
          res.data,
          this.filters.departureDateFromPeriod,
          this.filters.departureDateToPeriod
        );
      });
  }

  selectingAll = false;
  selectAllReservations(val: boolean) {
    this.selectingAll = true;
    this.axios
      .get<VReservation[]>(
        "/reservations/GetAllReservationsForForMultipleReservationsInvoicing",
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        if (val) {
          this.selected = res.data.map((x) => ({
            ...x,
            idUniq: `${x.reservationId}:${x.reservationAccUnitTypeId}`,
          }));
        } else {
          this.selected = this.selected.filter(
            (item) =>
              !res.data.some(
                (x) =>
                  x.reservationAccUnitTypeId === item.reservationAccUnitTypeId
              )
          );
        }
      })
      .finally(() => {
        this.scrollToTop();
        this.selectingAll = false;
      });
  }

  checkOfficialRatesExist(accUnitTypes: ReservationAccUnitModel[]) {
    let officialRatesExist = true;
    accUnitTypes.forEach((x) => {
      x.dayPrices.forEach((dp) => {
        let officialRate = x.officialRates.find(
          (or) =>
            parseStringToDateJS(or.dateFrom).getTime() <=
              parseStringToDateJS(dp.date.toString()).getTime() &&
            parseStringToDateJS(or.dateTo).getTime() >=
              parseStringToDateJS(dp.date.toString()).getTime() &&
            or.serviceTypeId === dp.serviceTypeId &&
            (this.tenantOBRsUseRelativePricing ||
              or.ratePlanId === x.ratePlan?.parentRatePlanId ||
              or.ratePlanId === x.ratePlan?.id)
        );
        if (officialRate === undefined) {
          officialRate = x.officialRates.find((or) => or.isMain);
        }
        if (officialRate === undefined) {
          officialRatesExist = false;
        }
      });
    });

    return officialRatesExist;
  }

  //initialListSize will be the maximum size this table can be
  //so selected array should be compared only to that initial state
  //anything less that that can be considered as -> not all selected
  areAllReservationsSelected() {
    return (
      this.selected.length === this.initialListSize &&
      (this.list.count ?? 0) > 0
    );
  }

  addOnServicesTranslations: AddOnServiceTranslation[] = [];
  async refreshAddOnServicesTranslations() {
    await Vue.axios
      .get<ListModel<AddOnServiceTranslation>>("addOnServices/translations")
      .then((res) => {
        this.addOnServicesTranslations = res.data.result;
      });
  }
}
